import {
  DEFAULT_CURRENCY_LOCALE,
  DEFAULT_CURRENCY_SYMBOL,
} from "@zenith/data/constants";

const MAX_DIGITS_LENGTH = 15;
const COMMAS_AND_PERIOD_LENGTH = 5;

/**
 * Formats the amount into a string,
 * with the currency symbol and
 * the currency format `1,234.56`.
 * @function
 * @name formatCurrency
 * @kind function
 * @param {number | string | undefined} amount The intended amount.
 * @param {boolean=} showCurrency Shows, or not, the currency symbol (`true` by default).
 * @returns {string} A string with the amount formatted.
 * @exports
 */
export function formatCurrency(
  amount: number | string | undefined,
  showCurrency = true
): string {
  if (!amount && amount !== 0) return "0.00";

  const formattedDigits = `${amount.toLocaleString(DEFAULT_CURRENCY_LOCALE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

  const truncatedValue = truncateValue(
    formattedDigits,
    MAX_DIGITS_LENGTH + COMMAS_AND_PERIOD_LENGTH
  );

  return showCurrency
    ? `${DEFAULT_CURRENCY_SYMBOL} ${truncatedValue}`
    : truncatedValue;
}

/**
 * Trucantes the given value,
 * so it's only shown a portion
 * of the real value.
 * @function
 * @name truncateValue
 * @kind function
 * @param {string} str The intended string value.
 * @param {number} max Maximum number of characters shown.
 * @returns {string} The truncated value.
 */
function truncateValue(str: string, max: number): string {
  return str.length > max ? str.substring(0, max - 3) + "..." : str;
}
